import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';

import Nav from '../routes';

const allowedTransitions = [Nav.Block, Nav.Clause];

export const useClearToastsOnNavigate = () => {
  const location = useLocation();

  useEffect(() => {
    const isAllowedTransition = allowedTransitions.some((path) => matchPath(path, location.pathname));

    if (!isAllowedTransition) {
      toast.dismiss();
    }
  }, [location.pathname]);
};
